module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/ice-cream-1-d6bfcda755463bff868c48d612a62a1b.svg";